import { Box, FileUpload, Icon } from "@chakra-ui/react"
import { FiUpload } from "react-icons/fi"
import FileUploadList from "./FileUploadList"

interface FileDropzoneProps {
  file?: File | null
  path?: string | null
  hidden?: boolean
  onClick?: () => void
}


const FileDropzone = ({file, path, hidden, onClick} : FileDropzoneProps) => {
    return (
        <>
            <FileUpload.Dropzone
                w="full"
                minH="fit-content"
                py={8}
                backgroundColor="unset"
                borderRadius={5}
                _hover={{_light: {bgColor: "secondary"}, _dark: {bgColor: "dark"}}}
                hidden={hidden}
            >
                <Icon as={FiUpload} size="md" color="dim" />

                <FileUpload.DropzoneContent>
                    <Box>Hier klicken oder hineinziehen um ein Bild hochzuladen</Box>
                </FileUpload.DropzoneContent>
            </FileUpload.Dropzone>

            {file && onClick ? (
                <FileUploadList
                    file={file}
                    path={path ?? null}
                    onClick={onClick}
                />
            ) : (
                <FileUpload.ItemGroup>
                    <FileUpload.Context>
                        {({ acceptedFiles }) =>
                            acceptedFiles.map((file, i) => (
                                <FileUploadList key={i} file={file} path={null} onClick={() => null} />
                            ))
                        }
                    </FileUpload.Context>
                </FileUpload.ItemGroup>
            )}
        </>
    )
}

export default FileDropzone
